@if (showMenu) {
  <div id="multiplePlacemarksMenu" appAdjustMenuPosition [position]="position" class="multiplePlacemarksMenuContainer">
    <perfect-scrollbar class="scrollbar">
      <ul id="menu" class="multiplePlacemarksList">
        @for (site of multipleSites; track site; let i = $index) {
          <li class="list-group multiplePlacemarksMenuItem">
            <a (click)="openSite($event,site)" #placemarkOption [attr.data-index]="i" class="list-group-item" style="white-space: nowrap;">
              <div class="placemarkIconContainer">
                <img class="icon placemarkIcon" alt="" id="placemarkIntersect" [src]="site.iconUrl | safe"/>
              </div>
              <div class="multiplePlacemarksMenuItemText" #objectName insTooltip [cfg]="getToolTipConf(objectName, site.name)">{{site.name}}</div>
            </a>
          </li>
        }
      </ul>
    </perfect-scrollbar>
  </div>
}